import React, { useEffect, useState } from "react";

type TrainingReviewCardProps = {
  fieldLabel: string;
  currentValue: string;
  proposedValue: string;
  justification: string;
  onAccept: (value: string) => void;
  onEdit: (editedValue: string) => void;
  onReject: () => void;
};

const TrainingReviewCard: React.FC<TrainingReviewCardProps> = ({
  fieldLabel,
  currentValue,
  proposedValue,
  justification,
  onAccept,
  onEdit,
  onReject,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState(proposedValue);

  useEffect(() => {
    setDraft(proposedValue);
    setIsEditing(false);
  }, [proposedValue]);

  if (isEditing) {
    return (
      <div className="mt-2 p-4 rounded-lg bg-purple-500/5 border border-purple-500/30">
        <div className="text-xs text-purple-300 mb-2">Edit proposed {fieldLabel.toLowerCase()}</div>
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          className="w-full bg-gray-900 border border-gray-700 text-gray-200 rounded-lg p-3 min-h-[90px]"
          aria-label="edit proposed value"
        />
        <div className="mt-3 flex gap-2">
          <button
            type="button"
            onClick={() => { onEdit(draft); setIsEditing(false); }}
            className="bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold px-4 py-2 rounded-lg"
          >
            Save
          </button>
          <button
            type="button"
            onClick={() => setIsEditing(false)}
            className="text-gray-400 hover:text-gray-200 text-sm px-4 py-2"
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-2 p-4 rounded-lg bg-purple-500/5 border border-purple-500/30">
      <div className="mb-2 text-xs uppercase tracking-wide text-gray-400">Current</div>
      <div className="text-sm text-gray-300 whitespace-pre-wrap">
        {currentValue || <span className="italic text-gray-500">(empty)</span>}
      </div>
      <div className="my-3 border-t border-gray-700/60" />
      <div className="mb-2 text-xs uppercase tracking-wide text-purple-300">✨ Proposed</div>
      <div className="text-sm text-gray-100 whitespace-pre-wrap">{proposedValue}</div>
      <div className="mt-3 text-xs text-gray-500 italic">Why: {justification}</div>
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          onClick={() => onAccept(proposedValue)}
          className="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-4 py-2 rounded-lg"
        >
          Accept
        </button>
        <button
          type="button"
          onClick={() => setIsEditing(true)}
          className="bg-gray-700 hover:bg-gray-600 text-gray-200 text-sm font-semibold px-4 py-2 rounded-lg"
        >
          Edit
        </button>
        <button
          type="button"
          onClick={onReject}
          className="text-gray-400 hover:text-gray-200 text-sm font-semibold px-4 py-2"
        >
          Reject
        </button>
      </div>
    </div>
  );
};

export default TrainingReviewCard;
